<template>
  <div id="decisoesWrapper">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres titulo="Decisões de Processos" />
      </template>
      <b-card-body>
        <CardFiltrosBusca>
          <b-form @submit.prevent="loadData" @reset.prevent="limparFiltros">
            <b-row>
              <b-col cols="12" lg="6">
                <b-form-group id="input-group-type" label-size="md" label="Nº Processo / Protocolo">
                  <b-form-input v-model="filtros.numero" />
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                <DateRangePickerBase v-model="filtros.dataPublicacao" title="Data de Publicação" />
              </b-col>
              <b-col id="input-group-filtroUg" cols="12" xl="6">
                <span class="d-block text-center pb-1">Unidade Gestora</span>
                <multiselect v-model="filtros.ug" open-direction="bottom" :close-on-select="true" :searchable="true"
                  deselect-label="" :allow-empty="true" placeholder="Selecione uma UG" track-by="IdPCM" :options="ugs"
                  label="Nome" :show-labels="false" :disabled="!ugs" class="wrapper-multiselect-sagres">
                  <template slot="noOptions">
                    <small><i>Erro ao obter dados.</i></small>
                  </template>
                  <template slot="noResult">
                    <i>Sem resultados.</i>
                  </template>
                </multiselect>
              </b-col>
              <b-col cols="6" xl="3" class="pt-4">
                <b-button type="reset" variant="outline-secondary">
                  <font-awesome-icon icon="redo" class="mr-3" />Limpar
                </b-button>
              </b-col>
              <b-col cols="6" xl="3" class="pt-4">
                <b-button type="submit" :disabled="isBusy">
                  <font-awesome-icon icon="search" class="mr-3" />Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </CardFiltrosBusca>
        <b-table :busy="isBusy" :fields="fields" hover no-border-collapse :items="items.decisoes" sort-by="DtProtocolo"
          :sort-desc="true" striped small show-empty stacked="md">
          <template #empty>
            <span>Não foram encontradas decisões.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontradas decisões para estes critérios.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <b-dropdown right no-caret>
              <template #button-content>
                <font-awesome-icon icon="bars" />
              </template>
              <b-dropdown-item v-if="row.item.cod_ato_acordao" :href="urlAnexo('decisao', row.item.cod_ato_acordao)"
                target="_parent">
                <font-awesome-icon icon="gavel" class="mr-2" />
                <span>Decisão</span>
              </b-dropdown-item>
              <b-dropdown-item v-if="row.item.parecermp" :href="urlAnexo('decisao', row.item.parecermp)"
                target="_parent">
                <font-awesome-icon icon="comment" class="mr-2" />
                <span>Parecer MP</span>
              </b-dropdown-item>
              <b-dropdown-item v-if="row.item.cod_multa" :href="urlAnexo('multa', row.item.multa)" target="_parent">
                <font-awesome-icon icon="ticket" class="mr-2" />
                <span>Multa</span>
              </b-dropdown-item>
              <b-dropdown-item-button v-if="row.item.criptoProt" @click="baixarPecaUnica(row.item.criptoProt)">
                <font-awesome-icon icon="book" class="mr-2" />
                <span>Íntegra</span>
              </b-dropdown-item-button>
            </b-dropdown>
          </template>
        </b-table>
        <table-pagination v-if="items.totalRows > 10" :total-rows="items.totalRows" :per-page="items.pageSize"
          @pageChange="pageChange" />
      </b-card-body>
    </b-card>
  </div>
</template>
<script lang="ts">
import protocoloService from "@/services/processos-eletronicos/protocoloService";
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import CardFiltrosBusca from '@/components/shared/CardFiltrosBusca.vue';
import HeaderSagres from '@/components/shared/HeaderSagres.vue';
import { tableFieldsDecisoes } from '@/types/processo-eletronico/decisoes/table-fields-decisoes';
import { UtilsTS } from '@/utilsts';
import { mixins } from 'vue-class-component';
import { Component, Vue } from 'vue-property-decorator';
import { RetornoListarDecisoes } from "@/types/processo-eletronico/decisoes/retorno-listar-decisoes";
import { FiltrosDecisoes } from "@/types/processo-eletronico/decisoes/filtros-decisoes";
import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";
import DateRangePickerBase from "@/components/shared/DateRangePickerBase.vue";
import { Multiselect } from 'vue-multiselect';
import { baixarArquivoPecaUnica, montarNomeArquivoPecaUnica } from "@/utils/peca-unica";
import { store } from "@/store"

const CompProps = Vue.extend({
  name: 'Decisoes',
  components: { CardFiltrosBusca, DateRangePickerBase, HeaderSagres, Multiselect, TablePagination }
})

@Component
export default class Decisoes extends mixins(UtilsTS, CompProps) {
  isBusy = false
  fields = [...tableFieldsDecisoes]
  filtros: FiltrosDecisoes = new FiltrosDecisoes()
  items: RetornoListarDecisoes = new RetornoListarDecisoes()
  ugs: UnidadeGestoraResumida[] = []

  /* avaliarNumeroEData(arg1, arg2): void {
    console.log('avaliarNumeroEData', arg1, arg2)
  } */
  async carregarUgs() {
    try {
      this.ugs = await protocoloService.filtrarUgs()
      if (store.codigoUG) this.filtros.ug = this.ugs.find(ug => ug.Codigo === store.codigoUG)
    } catch (e: any) {
      this.ugs = []
      this.tratarError(e)
    }
  }
  async loadData(): Promise<void> {
    try {
      this.isBusy = true;
      this.items = await protocoloService.getDecisoes(this.filtros);
    } catch (err: any) {
      this.items = new RetornoListarDecisoes()
      console.error("Erro ao obter decisões: ", err);
      this.$toast.error(err.message);
    } finally {
      this.isBusy = false;
    }
  }

  limparFiltros(): void {
    this.filtros.limpar();
  }
  pageChange(value): void {
    this.filtros.page = value;
    this.loadData();
  }
  urlAnexo(tipo: string, chave: number): string {
    if (tipo === 'decisao') return `https://www.tce.se.gov.br/consultas/ViewDecisao.aspx?id=${chave}`
    if (tipo === 'multa') return `https://www.tce.se.gov.br/consultas/ViewMulta.aspx?id=${chave}`
    console.error('Página de decisões tentou gerar uma url que não existe:', tipo, chave)
    return '#'
  }
  async baixarPecaUnica(codProtocoloCriptografado: string | number): Promise<void> {
    try {
      const codigo = String(codProtocoloCriptografado)
      const arquivo = await baixarArquivoPecaUnica(codigo)
      const nomeArquivo = `${montarNomeArquivoPecaUnica("processo", codigo)}.pdf`
      this.download(nomeArquivo, arquivo)
    } catch (err: any) {
      this.tratarError(err)
    }
  }
  async mounted() {
    await this.carregarUgs()
    await this.loadData();
  }
}
</script>
